import "./SliderText.css";

function SlidingText() {
  const text =
    "Rain or Shine - We're Out There";
  return (
    <div className="marquee">
      <div className="marquee__inner">
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span>
      </div>
    </div>
  );
}

export default SlidingText;
